import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { CheckoutSummaryResponse } from 'Types/CheckoutSummaryResponseType'

type QueryFnType = typeof getCheckoutSummary

export const useGetCheckoutSummary = (planIds: Array<number>, productTrial?: boolean) => {
  const accountId = useUserStore.getState().accountId
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['checkoutSummary', planIds],
    queryFn: () =>
      getCheckoutSummary(
        accountId,
        planIds.filter((num) => num > 0), // we don't want to send 0 as a plan id
        productTrial
      ),
    enabled: !!accountId && !!planIds.length && planIds[0] !== 0,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data
  return { ...query, data }
}

const getCheckoutSummary = async (
  accountId: number,
  planIds: Array<number>,
  productTrial?: boolean
): Promise<CheckoutSummaryResponse | Error> => {
  return await request<CheckoutSummaryResponse>({
    url: `/accounts/${accountId}/subscriptions/checkout`,
    method: 'POST',
    data: { products: planIds, productTrial: !!productTrial },
    hideErrorToaster: true,
  })
}
